import { configureStore } from '@reduxjs/toolkit'
import tokenReducer from './tokenslice'
import permissionReducer from './permissionSlice2'
import profileSlice from './profile_slice'
import UserServicesSlice from './userserviceslice'
import gmbDashboardSlice from './gmbDashboardSlice'

export const AccesstokenStore = configureStore({
  reducer: {
    Token: tokenReducer,
    Permissions: permissionReducer,
    profileStore: profileSlice,
    serviceStore: UserServicesSlice,
    gmbDashboardStore: gmbDashboardSlice
  },
})